import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import * as net from 'util/Net';

import {RequestTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTemplateGraphQL';
import {RequestTemplate, RequestTemplateSpec} from './RequestTemplateConstants';

export interface CreateRequestTemplateResponse {
  requestSchema: AssaySchema;
  template: RequestTemplate;
  templateGraphQL: RequestTemplateGraphQL;
}

export function createRequestTemplate(requestSchemaId: string): Promise<CreateRequestTemplateResponse> {
  return net.postJSONPromise({
    url: '/1/api/request-templates',
    data: {requestSchemaId},
  });
}

export interface RequestTemplateResponse {
  template: RequestTemplate;
  schemaSpec: RequestTemplateSpec;
  templateGraphQL: RequestTemplateGraphQL;
}

export function updateRequestTemplate(
  requestTemplateId: string,
  spec: RequestTemplateSpec
): Promise<RequestTemplateResponse> {
  return net.patchJSONPromise({
    url: `/1/api/request-templates/${requestTemplateId}`,
    data: {spec},
  });
}
